export default {
    incoming: 'Entrant',
    outgoing: 'Sortant',
};
